// Generated by ts-to-zod
import { z } from 'zod'

import { BLOCK_TYPE } from '../../../types/next/enums'

import { EntitySelectionMode } from './../../../types/next/blocks/entityFinderBlock'
import { iBlockSchema, blockBaseSettingsSchema } from './baseBlock.zod'
import { uncastObjectSchema } from './common.zod'
import { referenceIdSchema } from './ids.zod'
import {
  blockReferenceSchema,
  contextParameterReferenceSchema
} from './references.zod'

export const entitySelectionModeSchema = z.nativeEnum(EntitySelectionMode)

export const entityAttributesSchema = z.object({
  id: z.string(),
  label: z.string(),
  name: z.string()
})

const entityFinderSettingsSchema = z.object({
  showIcon: z.boolean(),
  multiSelect: z.boolean(),
  entity: z.string(),
  attributes: z.array(entityAttributesSchema),
  titleAttribute: z.string()
})

export const entityFinderBlockReferenceSchema = blockReferenceSchema.extend({
  meaning: z.literal('source')
})

export const entityFinderContextReferenceSchema =
  contextParameterReferenceSchema.extend({
    meaning: z.literal('source')
  })

export const entityListBasedEntityFinderBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.ENTITY_FINDER),
  settings: blockBaseSettingsSchema.and(entityFinderSettingsSchema).and(
    z.object({
      mode: z.literal(EntitySelectionMode.ENTITY_LIST)
    })
  ),
  references: z.object({})
})

export const otherBlockBasedEntityFinderBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.ENTITY_FINDER),
  settings: blockBaseSettingsSchema.and(entityFinderSettingsSchema).and(
    z.object({
      mode: z.literal(EntitySelectionMode.OTHER_BLOCK),
      relation: z.string(),
      relationSlug: z.string()
    })
  ),
  references: z.record(referenceIdSchema, entityFinderBlockReferenceSchema)
})

export const contextBasedEntityFinderBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.ENTITY_FINDER),
  settings: blockBaseSettingsSchema.and(entityFinderSettingsSchema).and(
    z.object({
      mode: z.literal(EntitySelectionMode.CONTEXT),
      relation: z.string(),
      relationSlug: z.string()
    })
  ),
  references: z.record(referenceIdSchema, entityFinderContextReferenceSchema)
})

export const entityFinderBlockSchema = z.union([
  entityListBasedEntityFinderBlockSchema,
  otherBlockBasedEntityFinderBlockSchema,
  contextBasedEntityFinderBlockSchema
])

export const entityFinderBlockValueSchema = z.object({
  entity: uncastObjectSchema.nullable(),
  slug: z.string().optional()
})
